var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#171E37",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.833 8.167c0 3.298-4.447 7.317-5.575 8.283a.394.394 0 01-.516 0c-1.128-.966-5.576-4.985-5.576-8.283C4.167 5.037 6.779 2.5 10 2.5c3.222 0 5.833 2.537 5.833 5.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10a1.667 1.667 0 100-3.333A1.667 1.667 0 0010 10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.b97faa26ae9d225bf7fe4f1379bd34f1.svg";
export { ForwardRef as ReactComponent };